<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <h2 class="p-4 text-muted">Biztonsági beállítások</h2>
    </div>
  </div>

  <div
    class="d-flex align-items-center justify-content-center"
    style="min-height: calc(100vh - 200px)"
  >
    <div class="col-md-8 col-lg-6 col-xl-5">
      <div class="d-flex flex-column gap-4">
        <!-- Password Change Card -->
        <div class="card">
          <div class="card-body d-flex align-items-center p-4">
            <div class="me-4">
              <i class="material-icons" style="font-size: 48px">vpn_key</i>
            </div>
            <div class="flex-grow-1">
              <h5 class="card-title mb-2">Jelszó módosítása</h5>
              <p class="card-text text-muted small mb-0">
                A felhasználói fiókhoz tartozó jelszó módosítása.
              </p>
            </div>
            <div>
              <button class="btn btn-primary" (click)="openChangePasswordDialog()">
                Módosítás
              </button>
            </div>
          </div>
        </div>

        <!-- MFA Setup Card -->
        <div class="card">
          <div class="card-body d-flex align-items-center p-4">
            <div class="me-4">
              <i class="material-icons" style="font-size: 48px">security</i>
            </div>
            <div class="flex-grow-1">
              <h5 class="card-title mb-2">2 faktoros azonosítás</h5>
              <div class="d-flex align-items-center mb-2">
                @if (twoFactorStatus(); as status) {
                  @if (status.twoFactorEnabled) {
                    <span class="badge bg-success me-2">Engedélyezve</span>
                    @for (m of status.activeMethods; track m) {
                      <span class="badge bg-light text-dark border me-1">{{ m }}</span>
                    }
                  } @else {
                    <span class="badge bg-danger me-2">Letiltva</span>
                  }
                } @else if (statusLoadFailed()) {
                  <span class="badge bg-secondary me-2">Az állapot nem elérhető</span>
                }
              </div>
              <p class="card-text text-muted small mb-0">
                Védje felhasználói fiókját a 2 lépcsős bejelentkezéssel.
              </p>
            </div>
            <div>
              <button class="btn btn-primary" (click)="openTwoFactorDialog()">
                @if (twoFactorStatus()?.twoFactorEnabled || statusLoadFailed()) { Kezelés } @else { Engedélyezés }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
